import {
	TFilterDropDownData,
} from "../../../../fixtures/data-fixtures/ComponentConfigFixtures";

export enum FILTER_SELECTION_TYPE {
	NONE,
	BASED_ON_SELECTION,
	REST,
	BOTH,
}

export interface IDropDownProps<T> {
	config: TFilterDropDownConfig;
	basedOnSelection: T[];
	rest: T[];
	currentSelection: T[];
	onDropDownFilterChange: (
		filterItems: T[],
		dimension: string,
		filterSelectionType?: FILTER_SELECTION_TYPE
	) => void;
}

export interface IDropDownListProps {
	filters: TFilterDropDownData[];
	searchString: string;
	selected: TFilterDropDownData[];
	header: string;
	onFilterChange;
}
